/**
 * "Scraping mode" block — rendered from two surfaces: the row kebab and the Mode cell's own menu.
 *
 * One item per mode with a check on the current one, as `role="menuitemradio"` items so the
 * single-selection semantics reach assistive tech and not just the eye. The caller owns the
 * mutation (and closes the menu). The kebab keeps the "Scraping mode" heading that separates the
 * block from its neighbours; the Mode cell drops it — there the whole menu is the mode picker.
 */

import { SCHEDULE_MODES, type ScheduleMode } from '@lw/shared';
import { MenuItem, MenuLabel } from '../../components';
import { SCHEDULE_MODE_LABEL } from '../../lib/labels';

export type ScheduleModeMenuItemsProps = {
  current: ScheduleMode;
  disabled?: boolean;
  /** The `Scraping mode` heading; on by default (the kebab needs it). */
  showLabel?: boolean;
  onSelect: (mode: ScheduleMode) => void;
};

export function ScheduleModeMenuItems({
  current,
  disabled = false,
  showLabel = true,
  onSelect,
}: ScheduleModeMenuItemsProps) {
  return (
    <>
      {showLabel ? <MenuLabel>Scraping mode</MenuLabel> : null}
      {SCHEDULE_MODES.map((mode) => (
        <MenuItem
          key={mode}
          role="menuitemradio"
          checked={mode === current}
          disabled={disabled}
          onClick={() => onSelect(mode)}
        >
          <span className="mode-check" aria-hidden="true">
            {mode === current ? '✓' : ''}
          </span>
          {SCHEDULE_MODE_LABEL[mode]}
        </MenuItem>
      ))}
    </>
  );
}

export default ScheduleModeMenuItems;
